<script setup lang="ts">
  defineProps({
    items: Array,
  });
</script>
<template>
  <section class="about-tiles-wrapper">
    <div class="about-tiles-wrapper__content section-wrapper">
      <article class="about-tiles-wrapper__item" v-for="item in items">
        <header class="about-tiles-wrapper__header">
          <MediaPicture :photo="item.photos" type="icon" class="about-tiles-wrapper__icon" />
          <span class="about-tiles-wrapper__title">
            {{ item.header }}
          </span>
        </header>
        <p class="about-tiles-wrapper__text" v-html="item.content"></p>
      </article>
    </div>
  </section>
</template>
<style scoped lang="scss">

  .about-tiles-wrapper {
    &__content {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 4rem;
      max-width: 1400px;
      margin: 0 auto;
    }

    &__item {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    &__header {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 1.5rem;
      font-weight: var(--font-weight-700);

      :deep(.about-tiles-wrapper__icon) {
        width: 75px;
        aspect-ratio: 1;

        img {
          aspect-ratio: 1;
        }
      }
    }

    &__text {
      font-weight: var(--font-weight-600);
    }
  }

  .single-tile {

    .tile-title {
      font-weight: 600;
      font-size: 28px;
      margin-top: 30px;
    }

    .tile-text {
      color: var(--color-gray);
    }

    .media-wrapper {
      max-width: 100px;
    }
  }

  .separator {
    margin: 22px 0;
  }

  @media (max-width: 1200px) {
    .about-tiles-wrapper {
      &__content {
        grid-template-columns: repeat(2, 1fr);
        gap: 3rem;
        padding-left: 1rem;
        padding-right: 1rem;
      }
    }
  }

  @media(max-width: 992px){

    .about-tiles-wrapper {
      &__content {
        grid-template-columns: 1fr;
        gap: 2rem;
        max-width: 1400px;
        margin: 0 auto;
      }

      &__item {
        display: flex;
        flex-direction: column;
        gap: 0.625rem;
      }

      &__header {
        font-size: 1rem;

        :deep(.about-tiles-wrapper__icon) {
          width: 70px;
        }
      }

      &__text {
        font-weight: var(--font-weight-600);
      }
    }
  }
</style>
